import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'dimdpopup',
    'phoneNum',
    'name',
    'email',
    'recvUserId',
    'checkedPriotyVote',
    'votableCnt',
    'timer',
    'voteType',
    'smsModal',
  ];

  connect() {}

  showModal() {
    //TODO 삭제 후 체크방식변경 필요-사유 modulation
    console.log(this.voteTypeTarget.value);
    if (this.voteTypeTarget.value == 'P') {
      if (!this.validateVoteCnt()) {
        window.$sendAlert(this.votableCntTarget.value + '개를 선택해야 투표를 진행할 수 있습니다.');
        return false;
      }
    } else {
      if (this.checkedPriotyVoteTargets.filter((vote) => vote.checked).length == 0) {
        window.$sendAlert('1개를 선택해야 투표를 진행할 수 있습니다.');
        return false;
      }
    }
    this.smsModalTarget.classList.remove('hidden');
  }

  closeModal() {
    this.smsModalTarget.classList.add('hidden');
  }

  //인증번호 전송
  sendSMS() {
    let $this = this;
    let url = '/ajax/send/sendSMS';
    const form_data = new FormData();
    form_data.append('phone', document.getElementById('phone').value);
    axios
      .post(url, form_data, {
        headers: Object.assign({}, _csrf, {
          'Content-Type': 'application/json',
        }),
      })
      .then(function (res) {
        document.getElementById('recvUserId').value = res.data.id;
        document.getElementById('email').value = res.data.email;
        document.getElementById('name').value = res.data.name;
        window.$sendNotice('문자가 발송되었습니다.');
        $this.ComTimer();
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  //인증번호 확인
  checkSMS() {
    let url = '/ajax/send/checkSMS';
    let data = {
      phone: document.getElementById('phone').value,
      userAuthNumber: document.getElementById('userAuthNumber').value,
      recvUserId: document.getElementById('recvUserId').value,
      email: document.getElementById('email').value,
      name: document.getElementById('name').value,
    };
    axios
      .post(url, JSON.stringify(data), {
        headers: Object.assign({}, _csrf, {
          'Content-Type': 'application/json',
        }),
      })
      .then(function (res) {
        this.closeModal();
        document.getElementById('createBtn').click();
        window.$sendNotice('문자인증이 완료되었습니다.');
        console.log(res);
      })
      .catch(function (err) {
        window.$sendNotice('인증번호를 확인해주세요.');
        console.log(err);
      });
  }

  ComTimer() {
    var AuthTimer = {
      comSecond: '',
      fnCallback: function () {},
      timer: '',
      domId: '',
      fnTimer: function () {
        if (this.comSecond == 180) {
          this.comSecond--;
        }
        var m = '제한시간 ' + Math.floor(this.comSecond / 60) + ':' + (this.comSecond % 60); // 남은 시간 계산
        this.domId.innerHTML = m;
        this.comSecond--; // 1초씩 감소

        if (this.comSecond < 0) {
          // 시간이 종료 되었으면..
          window.$sendAlert('인증시간이 초과하였습니다. 다시 인증해주시기 바랍니다.');
          this.fnStop();
        }
      },
      fnStop: function () {
        clearInterval(this.timer);
      },
    };
    if (timerId != '') {
      timerId.fnStop();
    }
    AuthTimer.comSecond = 180; // 제한 시간
    AuthTimer.fnCallback = function () {
      window.$sendAlert('다시 인증을 시도해주세요.');
    }; // 제한 시간 만료 메세지
    AuthTimer.timer = setInterval(function () {
      AuthTimer.fnTimer();
    }, 1000);
    AuthTimer.domId = document.getElementById('timer');
    timerId = AuthTimer;
  }

  validateVoteCnt() {
    const votedCnt = this.checkedPriotyVoteTargets.filter((vote) => vote.checked).length;
    if (this.votableCntTarget.value == -1) {
      return true;
    }
    if (votedCnt > this.votableCntTarget.value || votedCnt < 1) {
      return false;
    }
    return true;
  }
}
